module.exports = __webpack_public_path__ + "img/KR.44980451.png";